import { border, ink } from "../UI/tokens";
import styled from "styled-components";
import ButtonWithTooltip from "../ButtonWithTooltip";
import { Col, Row } from "react-bootstrap";

export const CelBreak = styled.div`
    width: 30vw;
    white-space: break-spaces;    

line-height: 1.6; overflow-wrap: anywhere;
`
export const CelBreak25 = styled.div`
    width: 25vw;
    white-space: break-spaces;    

line-height: 1.6; overflow-wrap: anywhere;
`

export const CelBreak15 = styled.div`
    width: 15vw;
    white-space: break-spaces;

line-height: 1.6; overflow-wrap: anywhere;
`

export const CelBreakTen = styled.div`
    width: 10vw;
    white-space: break-spaces;

line-height: 1.6; overflow-wrap: anywhere;
`

const BaseButton = styled(ButtonWithTooltip).attrs({ className: "ui-cell-button" })`
  && {
    font-family: inherit;
    font-size: inherit;
    font-weight: 700;
    line-height: inherit;
  }
  --bs-btn-bg: transparent;
  --bs-btn-hover-bg: transparent;
  --bs-btn-active-bg: transparent;
  --bs-btn-border-color: transparent;
  text-align: left;
`;

export const RedFont = styled(BaseButton)`
  --bs-btn-color: red;
  --bs-btn-active-color: red;
  --bs-btn-active-border-color: red;
  --bs-btn-hover-color: red;
  --bs-btn-hover-border-color: red;
`;

export const GreenFont = styled(BaseButton)`
  --bs-btn-color: #237753;
  --bs-btn-active-color: #237753;
  --bs-btn-active-border-color: #237753;
  --bs-btn-hover-color: #237753;
  --bs-btn-hover-border-color: #237753;  
`;

export const BlackFont = styled(BaseButton)`
  --bs-btn-color: #323232;
  --bs-btn-active-color: #323232;
  --bs-btn-active-border-color: #323232;
  --bs-btn-hover-color: #323232;
  --bs-btn-hover-border-color: #323232;  
`;

export const BlackFontTrello = styled(BlackFont)`
  font-size: 12px;
  padding: 0px;
`;

export const RedFontTrello = styled(RedFont)`
  font-size: 12px;
  padding: 0px;
`;

export const NormalFont = styled(BaseButton)`
  --bs-btn-color: ${ink};
  --bs-btn-active-color: ${ink};
  --bs-btn-active-border-color: ${ink};
  --bs-btn-hover-color: ${ink};
  --bs-btn-hover-border-color: ${ink};
`;

const DivDefault = styled(Col)`
    border: 1px solid;
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 1lvh 0.5lvw;
    border-color: ${border};
    margin-top: 0px!important;
    margin-bottom: 0px!important;
`;

export const DivBorder = styled(DivDefault)`
    background-color: ${({ theme }) => theme.bg2};
    color: white;
    font-size: 13px;
`

export const DivBorderDados = styled(DivDefault)`
    font-size: 12px;
`;

export const RowBorder = styled(Row)`
    margin-top: 0px!important;
    margin-bottom: 0px!important;
`;
